import { Component, computed, effect, signal } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, RoutesRecognized, Router, RouterEvent, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './layout/header/header.component';
import { Subject, takeUntil, throttleTime } from 'rxjs';
import { environment } from '../environments/default/environment';
import { CommonModule, Location } from '@angular/common';
import { PurpleFitFooterComponent } from './layout/purple-fit-footer/purple-fit-footer.component';
import { LayoutService } from './layout/layout.service';
import { PRPVUserFull, ApiPurpleFitRegisterRequest, ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitUpdateUserInfoRequest, CheckIfMustUpgradeResponse, PurpleFitUserManagerService, AuthorizationService } from '../core-modules/sdk';
import { PurpleTranslationService } from '@purple-lib/purple-translations-core';
import { PurpleApiError, PurpleApiErrorPage, PurpleApiErrorService, PurpleApiErrorWrapperComponent, PurpleApiMakeRequestResponse, PurpleBreakpointsService, PurpleErrorService, PurpleLoaderComponent, PurpleLoaderService, PurpleStorageService } from '@purple-lib/purple-utilities';
import { PurpleEditImageService } from '@purple-lib/purple-edit-medias';
import { PurpleEditTextService } from '@purple-lib/purple-edit-translations';
import { PurpleUserService, UserManagerService } from '@purple-lib/purple-users-core';
import { PurpleAdminToolComponent } from '@purple-lib/purple-admin-tool';
import { PurpleApiProxyService, PurpleSimpleNotificationService } from '@purple-lib/purple-ui-widgets';
import { PurpleFitCoreTranslations } from '../core-modules/constants/purple-fit-core-translations';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, HeaderComponent, PurpleLoaderComponent, PurpleFitFooterComponent, PurpleApiErrorWrapperComponent, PurpleAdminToolComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent {

  constructor(public loaderSvc: PurpleLoaderService, public tsvc: PurpleTranslationService, public editTextSvc: PurpleEditTextService,
    private router: Router, public editImgSvc: PurpleEditImageService,
    public breakSvc: PurpleBreakpointsService, private location: Location, private storageSvc: PurpleStorageService,
    private errorSvc: PurpleErrorService,
    private errorInterceptorSvc: PurpleApiErrorService,
    private apiProxySvc: PurpleApiProxyService,
    public layoutSvc: LayoutService,
    private authorizationSvc: AuthorizationService, private psNotSvc: PurpleSimpleNotificationService,
    public userSvc: PurpleUserService<PRPVUserFull, ApiPurpleFitRegisterRequest, ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitUpdateUserInfoRequest>) {

    this.router.events.subscribe((e: any) => {
      this.navigationInterceptor(e);
    });

    effect(() => {
      let errorInfo = this.errorInterceptorSvc.errorState();

      if (errorInfo != undefined) {
        switch (errorInfo.errorStatus) {
          case 0:
            this.loaderSvc.removeAllRequest(this.loaderId);
            break;

          case 401:
            //console.log("Errore 401")
            this.throttleLogout.next(1);
            break;

          default:
            break;
        }
      } else {
        this.errorInfo = undefined;
      }
    });
  }

  private throttleLogout = new Subject<any>();
  errorInfo: PurpleApiError | undefined = undefined;
  sub: Subject<void> = new Subject();
  loaderAdded: boolean = false;

  loaderId: string = environment.LOADER_ID;
  loaderSpeed: number = environment.LOADER_SPEED;
  loaderWidth = computed(() => {
    const deviceSize = this.breakSvc.breakPointDevice();
    return deviceSize === 'desktop'
      ? environment.LOADER_DESKTOP_WIDTH
      : environment.LOADER_MOBILE_WIDTH;
  })

  isMobile = computed(() => {
    const deviceSize = this.breakSvc.breakPointDevice();
    return deviceSize === 'desktop'
      ? false
      : true;
  })

  enableErrorPages: PurpleApiErrorPage[] = [
    {
      errorStatus: 0,
      errorTitle: "OPS SOMETHING WENT WRONG...",
      errorDescription: "It appears there was an error connecting to the server. Try reloading the page again.",
      errorButton: {
        text: "Back to locastion selection",
        fn: () => {
          this.storageSvc.remove("BasePath")
          window.location.reload();
        }
      }
    },
    {
      errorStatus: 404,
      errorTitle: "OPS PAGE NOT FOUND...",
      errorDescription: "It appears when router not exist.",
      errorButton: {
        text: "Back Home",
        fn: () => {
          this.location.historyGo(1);
          const url = `${this.tsvc.currentLanguage()}/dashboard`;
          this.location.go(url);
          window.location.reload();
        }
      }
    },
    {
      errorStatus: 401,
      errorTitle: "YOU ARE NOT AUTHENTICATED",
      errorDescription: "You have to make login to access this page.",
      errorButton: {
        text: "Login",
        fn: () => {
          this.location.historyGo(1);
          const url = `${this.tsvc.currentLanguage()}/login`;
          this.location.go(url);
          window.location.reload();
        }
      }
    }
  ]

  showTabMenu: boolean = environment.SHOW_TAB_MENU_MOBILE;
  showTabMenuCurrentRoute: boolean = false;

  ngOnInit() {
    this.updateTabMenuState();

    this.setAppHeight();
    this.throttleLogout.pipe(takeUntil(this.sub), throttleTime(5000)).subscribe(async url => {
      this.userSvc.logout();
      await this.router.navigate([this.tsvc.currentLanguage(), 'login']);
    });

    this.checkIfMustUpgrade();
  }


  async checkIfMustUpgrade() {
    await this.apiProxySvc.makeRequestErrorPurpleNotification<boolean>(() => this.authorizationSvc.checkClientVersion(this.tsvc.currentLanguage(),
      {
        clientVersion: environment.appVersion,
        clientType:"Web"
      })
      , false, environment.LOADER_ID, environment.API_CALL_LOADER_DELAY, (res: PurpleApiMakeRequestResponse<boolean>) => {
        return this.apiProxySvc.getDefaultErrorResponse(res, "modal", async () => { window.location.reload(); }, 'close', false, false)
      }, (res: PurpleApiMakeRequestResponse<boolean>) => {
       
      })
  }

  private updateTabMenuState() {
    if (!this.showTabMenu) {
      this.showTabMenuCurrentRoute = false;
      return;
    }

    let currentRoute = this.router.routerState.root;
    let showTabMenuParam: boolean | undefined = undefined;

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
      if (currentRoute.snapshot.data['showTabMenu'] !== undefined) {
        showTabMenuParam = currentRoute.snapshot.data['showTabMenu'];
      }
    }

    this.showTabMenuCurrentRoute = showTabMenuParam ?? false;
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.errorSvc.removeAllRequest("internal-error");
      this.layoutSvc.setFooterButton(undefined);
    }
    if (event instanceof RoutesRecognized) {
      let currentRoute = event.state.root;
      let showLoaderParam = true;

      while (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
        if (currentRoute.data['showLoader'] !== undefined) {
          showLoaderParam = currentRoute.data['showLoader'];
        }
      }

      if (showLoaderParam) {
        this.loaderSvc.addRequest(this.loaderId);
        this.loaderAdded = true;
      }
    }
    if (event instanceof NavigationEnd) {
      if (this.loaderAdded) {
        this.loaderSvc.removeRequest(this.loaderId, environment.ROUTING_LOADER_DELAY);
        this.loaderAdded = false;
      }
      this.updateTabMenuState();
    }

    if (event instanceof NavigationCancel) {
      if (this.loaderAdded) {
        this.loaderSvc.removeRequest(this.loaderId, environment.ROUTING_LOADER_DELAY);
        this.loaderAdded = false;
      }
    }
    if (event instanceof NavigationError) {
      this.errorInterceptorSvc.reportError({
        errorStatus: 404,
        text: "Route not found"
      })
      if (this.loaderAdded) {
        this.loaderSvc.removeRequest(this.loaderId, environment.ROUTING_LOADER_DELAY);
        this.loaderAdded = false;
      }
    }
  }

  ngOnDestroy() {
    this.sub.next();
    this.sub.complete();
  }

  setAppHeight() {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    doc.style.setProperty('--location-card-height', `${(window.innerHeight - (environment.SHOW_TAB_MENU_MOBILE ? 15 : 0)) / 2}px`)
    this.breakSvc.setScreenHeight();
  }

  ngAfterViewInit() {
    let lastFocusTime = 0;

    document.addEventListener('focusin', (e: any) => {
      if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) {
        lastFocusTime = Date.now();
      }
    }, { capture: true, passive: true });

    window.addEventListener('scroll', (e: Event) => {
      if (e.target instanceof Element) {
        if (e.target.closest('.cdk-overlay-container')) {
          return;
        }
      }

      if (this.isMobile()) {
        const dropdowns = document.querySelectorAll('.ant-select-dropdown, .ant-picker-dropdown');
        if (dropdowns.length > 0) {
          if (Date.now() - lastFocusTime > 500) {
            document.body.click();
          }
        }
      }
    }, { capture: true, passive: true });
  }


}
